
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/contact-us/submission-success",
      function () {
        return require("private-next-pages/us/contact-us/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/contact-us/submission-success"])
      });
    }
  